// extracted by mini-css-extract-plugin
export default {"search":"styles_search__BywcK","input__group":"styles_input__group__-0xmH"};